import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { usePlatformAuth } from '../context/PlatformAuthContext'

export default function PlatformPrivateRoute({ children }: { children: ReactNode }) {
    const { isAuthenticated, isLoading } = usePlatformAuth()
    const location = useLocation()

    if (isLoading) {
        return (
            <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress />
            </Box>
        )
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    return <>{children}</>
}
